import { site } from '~/data/site'

interface SeoInput {
  title: string
  description: string
  path: string
  image?: string
  type?: 'website' | 'article'
  siteName?: string
  imageAlt?: string
  twitterSite?: string
  jsonLd?: Record<string, unknown>[]
}

function absoluteUrl(origin: string, value: string) {
  if (/^https?:\/\//i.test(value)) return value
  return origin + (value.startsWith('/') ? value : `/${value}`)
}

/** Complete per-page SEO: meta tags, Open Graph, canonical and JSON-LD. */
export function useSeo(input: SeoInput) {
  // این استقرار چند-دامنه است، پس canonical باید از هدرهای همین درخواست
  // ساخته شود. بدون x-forwarded-* پشت پروکسی/CDN آدرس داخلی لو می‌رود.
  const requestUrl = useRequestURL({ xForwardedHost: true, xForwardedProto: true })
  const origin = requestUrl.hostname === 'localhost'
    ? site.url
    : requestUrl.origin
  const path = input.path.startsWith('/') ? input.path : `/${input.path}`
  const url = origin + path
  // عکس اختیاری است: قبلاً یک مسیر پیش‌فرض ست می‌شد که در public/ وجود
  // نداشت و og:image همه‌ی صفحه‌ها ۴۰۴ می‌داد.
  const image = input.image ? absoluteUrl(origin, input.image) : undefined

  useSeoMeta({
    title: input.title,
    description: input.description,
    ogTitle: input.title,
    ogDescription: input.description,
    ogUrl: url,
    ogType: input.type ?? 'website',
    ogSiteName: input.siteName ?? site.name,
    ogLocale: site.locale,
    twitterCard: image ? 'summary_large_image' : 'summary',
    twitterTitle: input.title,
    twitterDescription: input.description,
    twitterSite: input.twitterSite,
    ...(image
      ? {
          ogImage: image,
          ogImageAlt: input.imageAlt,
          twitterImage: image,
          twitterImageAlt: input.imageAlt
        }
      : {}),
    // به گوگل اجازه‌ی نمایش تصویر بزرگ و اسنیپت کامل می‌دهد.
    robots: 'index, follow, max-image-preview:large, max-snippet:-1'
  })

  useHead({
    link: [{ rel: 'canonical', href: url }],
    script: (input.jsonLd ?? []).map(data => ({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(data).replace(/</g, '\\u003c')
    }))
  })
}
